import { ZIndex } from '@flatfile/design-system'
import styled from 'styled-components'

export const ContentContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  position: relative;
  z-index: ${ZIndex.level100};
`
